"use strict";
import classNames from "classnames";
import React, { forwardRef } from "react";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
import * as styles from "./Label-css";
export const Label = forwardRef(
  ({
    size = "m",
    element = "span",
    secondary,
    align,
    long,
    hidden,
    theme,
    className,
    id,
    children,
    htmlFor,
    disabled,
    truncate,
    ...rest
  }, ref) => {
    const LabelElement = htmlFor ? "label" : element;
    return /* @__PURE__ */ React.createElement(
      LabelElement,
      {
        id,
        htmlFor,
        className: classNames(
          "kl-label",
          className,
          `kl-label--size-${size}`,
          {
            [darkTheme]: theme === "dark",
            [lightTheme]: theme === "light",
            "kl-label--secondary": secondary,
            "kl-label--hidden": hidden,
            "kl-label--long": long,
            "kl-label--disabled": disabled,
            [`kl-label--align-${align}`]: align
          },
          styles.label({ size, secondary, align, long, hidden, disabled, truncate })
        ),
        ref,
        ...rest
      },
      children
    );
  }
);
